import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "@/index.css";
import "./index.css";
import Routes from "./routes";
import { Provider } from "react-redux";
import store from "./app/store";

createRoot(document.getElementById("root")).render(
    <BrowserRouter>
      <Provider store={store}>
        <Routes />
      </Provider>
    </BrowserRouter>  
);
